import React, { useEffect, useState } from "react";
import { agentTxnColDef, agentTxnFilterCol } from "../constants";
import ReportHeader from "../../../common/ReportHeader";
import { Box, Divider, Typography } from "@mui/material";
import ReportTableFilter from "../../../common/ReportTableFilter";
import ExcelAndPrint from "../../../common/ExcelAndPrint";
import VirtualizedTable from "../../../common/VirtualizedTable";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showErrorAlert } from "../../../redux/Actions";
import { getRptAgentTransactionsData } from "../../../redux/Report/ReportActions";
import LoaderScreen from "../../../common/LoaderScreen";
import dayjs from "dayjs";
import { reportGenerationDateFormat } from "../../../common/constant";
import { decryptText } from "../../../utils/Decrypt";

const AgentTransactions = () => {
  const [tableData, setTableData] = useState([]);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [paramsLoaded, setParamsLoaded] = useState(false);

  let decryptedData = {}
  try {
    const paramData = searchParams.get("data");
    if (paramData) {
      decryptedData = JSON.parse(decryptText(decodeURIComponent(paramData)));
    }
  } catch (error) {
    console.error("Invalid query data:", error);
  }

  const { fromDate, toDate, operatorID, operator, typeID, type, intAgentUserID, intAgentID } = decryptedData

  useEffect(() => {
    if (searchParams.toString()) {
      setParamsLoaded(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!paramsLoaded) return;
    const requiredFields = [fromDate, toDate, operatorID, typeID];

    const hasError = requiredFields.some(
      (val) => val === undefined || val === null
    );

    if (hasError) {
      dispatch(showErrorAlert("Invalid URL: Missing required parameters"));
      return;
    }

    const body = {
      intUserID: Number(intAgentUserID),
      intAgentID: Number(intAgentID),
      intCompanyID: operatorID,
      dtFromDate: fromDate,
      dtToDate: toDate,
      strTxnType:
        typeID === 1 ? "B" : typeID === 2 ? "C" : typeID === 3 ? "R" : "",
    };

    dispatch(getRptAgentTransactionsData(body))
      .then((res) => {
        if (res.data.status) {
          const parsedData = JSON.parse(res.data.Data);
          const table = parsedData?.Table || [];
          const data = table.map((val, index) => ({ ...val, SrNo: index + 1 }));
          setTableData(data);
        } else {
          dispatch(showErrorAlert(res.data.Message));
        }
      })
      .catch(() => {
        dispatch(showErrorAlert("Failed to load user collection report"));
      });
  }, [paramsLoaded, fromDate, toDate, intAgentUserID, intAgentID, dispatch]);

  if (!paramsLoaded) {
    return <LoaderScreen />;
  }
  const filterData = {
    // user: intAgentUserID,
    date: `${dayjs(fromDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} to ${dayjs(toDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}`,
    operators: operator,
    types: type,
    reportDate: dayjs(window.getTime ? window.getTime() : new Date()).format(
      reportGenerationDateFormat,
    ),
  };
  return (
    <>
      <ReportHeader reportitle=" Agent Transactions Report" />
      <Box sx={{ padding: "12px 16px 8px 16px" }}>
        <ReportTableFilter columnDef={agentTxnFilterCol} data={filterData} />
      </Box>
      <Box
        sx={{
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6"></Typography>
        <ExcelAndPrint
          reportTitle="Agent Transactions Report"
          multiTable={[
            {
              titleTable: "",
              columnDef: agentTxnColDef,
              body: tableData,
            },
          ]}
          filterSectionColumn={agentTxnFilterCol}
          filterSectionData={filterData}
        />
      </Box>
      <Divider />
      <Box sx={{ padding: "12px 16px" }}>
        <VirtualizedTable tableData={tableData} columnDefs={agentTxnColDef} />
      </Box>
    </>
  );
};

export default AgentTransactions;
